export const Export = "Export/";

export const FileExport = Export + "FileExport";
export const FileExportFunction = Export + "FileExportFunction";